import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { VetDetailsPropTypes } from '../../../propTypes/vetDetails';
import { GetVetsByPolicyNumber } from '../../../helpers/vetHelpers';
import { VetNameAndAddress } from '../vetNameAndAddress/vetNameAndAddress';
import './vetDetailsList.scss';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { PetsTreatedList } from '../petsTreatedList/petsTreatedList';

const INITIAL_VETS_TO_SHOW = 8;

export const VetDetailsList = ({
  isEditable = true,
  isFullDetailView = false,
  petDetails,
  vetDetails,
  onVetUpdate,
  filter
}) => {
  const filteredVets = filter ? GetVetsByPolicyNumber({ vetDetails, policyNumber: filter }) : vetDetails;
  const [vetsToShow, setVetsToShow] = useState(INITIAL_VETS_TO_SHOW);

  const handleUpdateVet = ({ vetDetail }) => {
    onVetUpdate({ vetDetail });
  };

  const handleShowMore = () => {
    setVetsToShow((prevCount) => prevCount + 5);
  };

  return (
    <>
      <ul className={`vetDetailsList ${isFullDetailView ? 'fullDetailView' : ''}`}>
        {filteredVets?.slice(0, vetsToShow).map((vetDetail) => {
          const { ServiceProviderNumber, VetName, ServiceProviderName, PetsTreated } = vetDetail;

          return (
            <li key={`${ServiceProviderNumber}_${ServiceProviderName}_${VetName}`}>
              <VetNameAndAddress
                vetDetail={vetDetail}
                isFullDetailView={isFullDetailView}
              />

              {isFullDetailView && (
                <PetsTreatedList
                  petDetails={petDetails}
                  petsTreated={PetsTreated}
                />
              )}

              {isEditable && (
                <button
                  type="button"
                  onClick={() => handleUpdateVet({ vetDetail })}
                  className="button primary outline"
                >
                  <Icon icon="pencil" />
                  <span className="labelText">Update</span>
                </button>
              )}
            </li>
          );
        })}
      </ul>
      <div className="showMoreWrapper">
        {filteredVets.length > 0 && filteredVets.length > vetsToShow && (
          <button
            type="button"
            className="button secondary showMoreButton "
            onClick={handleShowMore}
          >
            Show more
          </button>
        )}
      </div>
    </>
  );
};

VetDetailsList.propTypes = {
  isEditable: PropTypes.bool,
  isFullDetailView: PropTypes.bool,
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  vetDetails: PropTypes.arrayOf(VetDetailsPropTypes),
  onVetUpdate: PropTypes.func,
  filter: PropTypes.string
};
